import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddGalleryLayer from "../components/AddGalleryLayer";

const AddGalleryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Gallery Add' />

        {/* AddBlogLayer */}
        <AddGalleryLayer />
      </MasterLayout>
    </>
  );
};

export default AddGalleryPage;
